export interface StoreSelectionCookie {
  buCode: string;
  buType: string;
}

const COOKIE_PREFIX = "store_selection_";
const COOKIE_DAYS = 30;

function getCookieName(marketCode: string): string {
  return `${COOKIE_PREFIX}${marketCode}`;
}

export function getStoreSelectionCookie(marketCode: string): StoreSelectionCookie | null {
  const name = getCookieName(marketCode);
  const cookies = document.cookie.split(";");
  for (const cookie of cookies) {
    const trimmed = cookie.trim();
    const eqIndex = trimmed.indexOf("=");
    if (eqIndex === -1) continue;
    const key = trimmed.substring(0, eqIndex);
    const value = trimmed.substring(eqIndex + 1);
    if (key === name) {
      try {
        return JSON.parse(atob(value));
      } catch {
        try {
          return JSON.parse(decodeURIComponent(value));
        } catch {
          return null;
        }
      }
    }
  }
  return null;
}

export function setStoreSelectionCookie(marketCode: string, buCode: string, buType: string): void {
  const name = getCookieName(marketCode);
  const expires = new Date();
  expires.setDate(expires.getDate() + COOKIE_DAYS);
  const value = btoa(JSON.stringify({ buCode, buType }));
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Strict`;
}
